import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ToolBarComponent,
  ToolbarActionsStartDirective,
  ToolbarActionsEndDirective,
} from './toolbar.component';

@NgModule({
  declarations: [
    ToolBarComponent,
    ToolbarActionsStartDirective,
    ToolbarActionsEndDirective,
  ],
  imports: [CommonModule],
  exports: [
    ToolBarComponent,
    ToolbarActionsStartDirective,
    ToolbarActionsEndDirective,
  ],
})
export class ToolBarModule {}
